import AnalyticsIcon from '@mui/icons-material/Analytics';
import AssessmentIcon from '@mui/icons-material/Assessment';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import InsightsIcon from '@mui/icons-material/Insights';
import TableChartIcon from '@mui/icons-material/TableChart';
import SummarizeIcon from '@mui/icons-material/Summarize';
import StorefrontIcon from '@mui/icons-material/Storefront';

import FileUploadIcon from "@mui/icons-material/FileUpload";
import BackupIcon from '@mui/icons-material/Backup';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import CategoryIcon from '@mui/icons-material/Category';
import BugReportIcon from '@mui/icons-material/BugReport';
import HandshakeIcon from '@mui/icons-material/Handshake';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import GroupIcon from '@mui/icons-material/Group';
import BlockIcon from '@mui/icons-material/Block';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import BarChartIcon from '@mui/icons-material/BarChart';
import CrisisAlertIcon from '@mui/icons-material/CrisisAlert';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import HandymanIcon from '@mui/icons-material/Handyman';
import CancelScheduleSendIcon from '@mui/icons-material/CancelScheduleSend';
import ApprovalIcon from '@mui/icons-material/Approval';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

const icons = {
    AnalyticsIcon,
    AssessmentIcon,
    QueryStatsIcon,
    InsightsIcon,
    TableChartIcon,
    SummarizeIcon,
    StorefrontIcon,
    HowToRegIcon,
    CheckCircleIcon,
    PendingActionsIcon,
    HandymanIcon,
    CancelScheduleSendIcon,
    ApprovalIcon,
    FileUploadIcon,
    BackupIcon,
    Inventory2Icon,
    LocationCityIcon,
    CategoryIcon,
    BugReportIcon,
    HandshakeIcon,
    AccountBalanceIcon,
    GroupIcon,
    BlockIcon,
    HighlightOffIcon,
    CardGiftcardIcon,
    BarChartIcon,
    CrisisAlertIcon,
    NotificationsActiveIcon,
    ReceiptLongIcon,
};

const allMIS = {
    id: 'all_mis_reports',
    title: 'MIS Download',
    type: 'group',
    icon: icons.AnalyticsIcon,
    children: [
        {
            id: 'Master_MIS',
            title: 'Master MIS',
            type: 'item',
            url: '/MIS-REPORT',
            icon: icons.AssessmentIcon,
        },
        {
            id: 'Agent_MIS',
            title: 'Agent MIS',
            type: 'item',
            url: '/agent-MIS-report',
            icon: icons.GroupIcon,
        },
        {
            id: 'Network_MIS',
            title: 'Network MIS',
            type: 'item',
            url: '/network-MIS-report',
            icon: icons.QueryStatsIcon,
        },
        // {
        //     id: 'Vendor_MIS',
        //     title: 'Vendor MIS',
        //     type: 'item',
        //     url: '/Intimation-MIS-Tracker',
        //     icon: icons.Inventory2Icon,
        // },
        // {
        //     id: 'Dealer_MIS',
        //     title: 'Dealer MIS',
        //     type: 'item',
        //     url: '/Intimation-MIS-Tracker',
        //     icon: icons.StorefrontIcon,
        // },
        // {
        //     id: 'Accounts_MIS',
        //     title: 'Accounts MIS',
        //     type: 'item',
        //     url: '/Intimation-MIS-Tracker',
        //     icon: icons.AccountBalanceIcon,
        // },
        // {
        //     id: 'Business_MIS',
        //     title: 'Business MIS',
        //     type: 'item',
        //     url: '/Intimation-MIS-Tracker',
        //     icon: icons.InsightsIcon,
        // },
        {
            id: 'Intimation_MIS',
            title: 'Intimation MIS',
            type: 'item',
            url: '/Intimation-MIS-Tracker',
            icon: icons.NotificationsActiveIcon,
        },
        // {
        //     id: 'Payment_History',
        //     title: 'Payment History',
        //     type: 'item',
        //     url: '/payment_history',
        //     icon: icons.ReceiptLongIcon,
        // }
    ]
};

export default allMIS;